import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

type Props = {
  open: boolean;
  count: number;
  isDeleting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export function DeleteFilesModal({
  open,
  count,
  isDeleting = false,
  onClose,
  onConfirm,
}: Props) {
  const label = count === 1 ? "arquivo" : "arquivos";

  return (
    <Dialog open={open} onClose={isDeleting ? undefined : onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontWeight: 600 }}>Excluir arquivos?</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          Você está prestes a remover {count} {label}. Esta ação não pode ser desfeita.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={isDeleting} sx={{ textTransform: "none" }}>
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={isDeleting}
          sx={{ textTransform: "none" }}
        >
          {isDeleting ? "Excluindo..." : "Excluir"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
